var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app_js",class:{
    'main-gradient': _vm.isGradient
  },attrs:{"id":"app"}},[(!_vm.$auth.loading)?[(_vm.$auth.isAuthenticated)?_c('vue-extend-layouts'):_c('router-view')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }